export enum ExternalKeysProviders {
    Elevenlabs = 'elevenlabs',
    Microsoft = 'microsoft',
    OpenAI = 'openai',
}
